<template>
    <IdentityFields :label="$translateLabel(field.label, field.name)" :field="field" v-model="input" @error="fieldError"  :disabled="field.protected" :page="page" :store="$store" :context="context" :translator="$t"></IdentityFields>
</template>

<script>
import IdentityFields from '@/components/identityFields/IdentityFields'

export default {
    components: {
        IdentityFields
    },
    props: {
        field: {
            type: Object
        },

        model: {
            type: Object
        },

        fields: {
            type: Array
        },

        isEdit: {
            type: Boolean
        }
    },

    data: function() {
        return {
            errors: [],
            data: {}
        }  
    },

    computed: {
        input: {
            get() {
                return this.model
            },
            
            set(e) {
                this.data = Object.assign(this.data, e)
                this.$emit('modelChanged', this.data)
            }
        },

        context() {
            return {
                model: _.cloneDeep(this.data),
                fields: this.fields
            }
        },

        page() {
            if (this.isEdit) return 'model_edit'

            return null
        }
    },

    methods: {
        fieldError(error) {
            let found = this.errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                this.errors.push(error)
            } else {
                this.errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        }
    }
}
</script>